import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHtmlacademyComponent } from './simple-icons-htmlacademy.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHtmlacademyComponent ],
    exports:      [ SimpleIconsHtmlacademyComponent ],
    bootstrap:    []
})
export class SimpleIconsHtmlacademyModule {}
